import { render, staticRenderFns } from "./competitive_collection.vue?vue&type=template&id=011f0df6&scoped=true"
import script from "./competitive_collection.vue?vue&type=script&lang=js"
export * from "./competitive_collection.vue?vue&type=script&lang=js"
import style0 from "./competitive_collection.vue?vue&type=style&index=0&id=011f0df6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011f0df6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011f0df6')) {
      api.createRecord('011f0df6', component.options)
    } else {
      api.reload('011f0df6', component.options)
    }
    module.hot.accept("./competitive_collection.vue?vue&type=template&id=011f0df6&scoped=true", function () {
      api.rerender('011f0df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/competitive_collection.vue"
export default component.exports